(function () {
  const STORAGE_KEY = 'badminton_store_preorder_list_v1';
  const WHATSAPP_NUMBER = '919384852211';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    renderCartList();
  }

  function addItem(button) {
    const item = {
      productId: button.dataset.productId,
      variantId: button.dataset.variantId,
      title: button.dataset.title,
      url: button.dataset.url,
      image: button.dataset.image,
      price: button.dataset.price,
      qty: 1
    };

    let list = getList();

    const existing = list.find(function (x) {
      return x.variantId === item.variantId;
    });

    if (existing) {
      existing.qty += 1;
    } else {
      list.push(item);
    }

    saveList(list);

    const oldText = button.textContent;
    button.textContent = 'Added to Pre-order List';
    button.disabled = true;

    setTimeout(function () {
      button.textContent = oldText;
      button.disabled = false;
    }, 1500);
  }

  function updateQty(variantId, action) {
    let list = getList();

    list = list.map(function (item) {
      if (item.variantId === variantId) {
        if (action === 'increase') item.qty += 1;
        if (action === 'decrease') item.qty -= 1;
      }
      return item;
    }).filter(function (item) {
      return item.qty > 0;
    });

    saveList(list);
  }

  function removeItem(variantId) {
    const list = getList().filter(function (item) {
      return item.variantId !== variantId;
    });

    saveList(list);
  }

  function sendWhatsAppSummary() {
    const list = getList();

    if (!list.length) return;

    let message = 'Hi Badminton Store, I want to pre-order these products:\n\n';

    list.forEach(function (item, index) {
      message += `${index + 1}. ${item.title}\n`;
      message += `Quantity: ${item.qty}\n`;
      message += `Shown price: ${item.price}\n`;
      message += `Product link: ${item.url}\n\n`;
    });

    message += 'City:\n\nPlease confirm latest price, availability, and delivery timeline before payment.';

    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank');
  }

  function renderCartList() {
    if (!window.location.pathname.includes('/cart')) return;

    let mount = document.getElementById('preorder-cart-list');

    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'preorder-cart-list';

      const cartItems = document.querySelector('cart-items') || document.querySelector('.cart__items') || document.querySelector('main');

      if (cartItems && cartItems.parentNode) {
        cartItems.parentNode.insertBefore(mount, cartItems.nextSibling);
      }
    }

    const list = getList();

    if (!list.length) {
      mount.innerHTML = '';
      return;
    }

    const itemsHtml = list.map(function (item) {
      return `
        <div class="preorder-cart-item">
          <div>
            ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
          </div>
          <div>
            <div class="preorder-cart-title">${item.title}</div>
            <div class="preorder-cart-meta">
              ${item.price} · Pre-order request only — not billed now
            </div>
            <div class="preorder-actions">
              <button type="button" data-preorder-action="decrease" data-variant-id="${item.variantId}">−</button>
              <span>${item.qty}</span>
              <button type="button" data-preorder-action="increase" data-variant-id="${item.variantId}">+</button>
              <button type="button" class="preorder-remove" data-preorder-action="remove" data-variant-id="${item.variantId}">Remove</button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    mount.innerHTML = `
      <style>
        .preorder-cart-box {
          margin: 24px 0;
          padding: 20px;
          border: 1px solid rgba(0,0,0,.12);
          border-radius: 14px;
          background: #fff;
        }

        .preorder-cart-box h2 {
          margin: 0 0 8px;
          font-size: 24px;
        }

        .preorder-cart-note {
          margin: 0 0 16px;
          font-size: 14px;
          line-height: 1.5;
          opacity: .8;
        }

        .preorder-cart-item {
          display: grid;
          grid-template-columns: 72px 1fr;
          gap: 14px;
          padding: 14px 0;
          border-top: 1px solid rgba(0,0,0,.08);
        }

        .preorder-cart-item img {
          width: 72px;
          height: 72px;
          object-fit: contain;
          border-radius: 8px;
          background: #f7f7f7;
        }

        .preorder-cart-title {
          font-weight: 600;
          margin-bottom: 4px;
        }

        .preorder-cart-meta {
          font-size: 13px;
          opacity: .75;
          margin-bottom: 10px;
        }

        .preorder-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .preorder-actions button {
          min-width: 34px;
          height: 34px;
          border: 1px solid rgba(0,0,0,.2);
          background: #fff;
          border-radius: 6px;
          cursor: pointer;
        }

        .preorder-remove {
          text-decoration: underline;
          border: 0 !important;
          background: transparent !important;
          width: auto !important;
          min-width: auto !important;
        }

        .preorder-whatsapp-btn {
          margin-top: 16px;
        }

        @media(max-width: 749px) {
          .preorder-cart-box {
            padding: 16px;
          }

          .preorder-cart-box h2 {
            font-size: 20px;
          }
        }
      </style>

      <div class="preorder-cart-box">
        <h2>Pre-order Requests</h2>
        <p class="preorder-cart-note">
          These products are not included in your checkout total. We will try to procure them and our customer care team will contact you with availability, latest price, and estimated delivery timeline before payment.
        </p>

        ${itemsHtml}

        <button type="button" class="button button--full-width preorder-whatsapp-btn" data-preorder-action="whatsapp">
          Send Pre-order Request on WhatsApp
        </button>
      </div>
    `;
  }

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('.js-preorder-add');

    if (addButton) {
      event.preventDefault();
      addItem(addButton);
      return;
    }

    const actionButton = event.target.closest('[data-preorder-action]');

    if (!actionButton) return;

    const action = actionButton.dataset.preorderAction;
    const variantId = actionButton.dataset.variantId;

    if (action === 'increase') updateQty(variantId, 'increase');
    if (action === 'decrease') updateQty(variantId, 'decrease');
    if (action === 'remove') removeItem(variantId);
    if (action === 'whatsapp') sendWhatsAppSummary();
  });

  document.addEventListener('DOMContentLoaded', function () {
    renderCartList();
  });
})();